"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _migrationApi = require("../api/migrationApi");
var _projectManageApi = require("@/api/projectManageApi");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MigrationLogDialog',
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      successCount: 0,
      failCount: 0,
      pageFrom: {
        page: 1,
        limit: 10
      },
      searchForm: {
        time: null,
        appId: null
      },
      miniappList: [],
      inheritedCustomerId: null
    };
  },
  methods: {
    open: function open(customerId) {
      this.dialogVisible = true;
      this.inheritedCustomerId = customerId;
      this.pageFrom.page = 1;
      this.pageFrom.limit = 10;
      this.searchForm.time = null;
      this.searchForm.appId = null;
      this.loadMiniappList();
      this.loadData(customerId);
    },
    close: function close() {
      this.dialogVisible = false;
    },
    handleSearch: function handleSearch() {
      this.pageFrom.page = 1;
      this.loadData(this.inheritedCustomerId);
    },
    handleReset: function handleReset() {
      this.searchForm.time = null;
      this.searchForm.appId = null;
      this.pageFrom.page = 1;
      this.loadData(this.inheritedCustomerId);
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.loadData(this.inheritedCustomerId);
    },
    handlePageChange: function handlePageChange(page) {
      this.pageFrom.page = page;
      this.loadData(this.inheritedCustomerId);
    },
    loadData: function () {
      var _loadData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(customerId) {
        var params, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              params = {
                page: this.pageFrom.page,
                limit: this.pageFrom.limit
              };
              if (customerId) {
                params.customerId = customerId;
              }
              if (this.searchForm.time && this.searchForm.time.length === 2) {
                params.startTime = this.searchForm.time[0];
                params.endTime = this.searchForm.time[1];
              }
              if (this.searchForm.appId) {
                params.appId = this.searchForm.appId;
              }
              _context.n = 2;
              return (0, _migrationApi.dataMigrationLogListApi)(params);
            case 2:
              res = _context.v;
              // request 拦截器已自动解包，res 即为 data 对象
              if (res && _typeof(res) === 'object' && Array.isArray(res.list)) {
                this.tableData = res.list;
                this.total = res.total || 0;
                this.calcStats();
              } else {
                this.tableData = [];
                this.total = 0;
                this.successCount = 0;
                this.failCount = 0;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取迁移日志列表失败', _t);
              this.$message.error('获取迁移日志列表失败');
              this.tableData = [];
              this.total = 0;
              this.successCount = 0;
              this.failCount = 0;
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function loadData(_x) {
        return _loadData.apply(this, arguments);
      }
      return loadData;
    }(),
    calcStats: function calcStats() {
      this.successCount = this.tableData.reduce(function (sum, row) {
        return sum + (row.successNum || 0);
      }, 0);
      this.failCount = this.tableData.reduce(function (sum, row) {
        return sum + (row.failNum || 0);
      }, 0);
    },
    loadMiniappList: function () {
      var _loadMiniappList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _projectManageApi.getMiniappList)();
            case 1:
              res = _context2.v;
              this.miniappList = res || [];
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error('获取小程序列表失败', _t2);
              this.miniappList = [];
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadMiniappList() {
        return _loadMiniappList.apply(this, arguments);
      }
      return loadMiniappList;
    }(),
    getAvatarText: function getAvatarText(name) {
      if (!name) return '?';
      return name.length > 2 ? name.slice(-2) : name;
    },
    downloadFile: function downloadFile(row) {
      if (!row.fileUrl) {
        this.$message.warning('文件地址不存在');
        return;
      }
      window.open(row.fileUrl, '_blank');
    },
    getFailReasonText: function getFailReasonText(failReason) {
      if (!failReason) return '';
      try {
        var parsed = JSON.parse(failReason);
        if (Array.isArray(parsed)) {
          return parsed.join('\n');
        }
        return String(parsed);
      } catch (_unused) {
        return String(failReason);
      }
    }
  }
};